import { render } from "./TimeField.vue?vue&type=template&id=20e8a962"
import script from "./TimeField.vue?vue&type=script&lang=js"
export * from "./TimeField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__